export default __webpack_public_path__ + "static/media/bracket_tbv_ketelisolatie_verend.742ea710.png";